(function () {
  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: currency || 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function wireQuickAdd(button, cartAddUrl) {
    button.addEventListener('click', function () {
      var variantId = button.dataset.variantId;
      if (!variantId) return;
      button.disabled = true;
      var originalText = button.textContent;
      button.textContent = 'A adicionar...';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.reload();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  }

  var configEl = document.querySelector('[data-product-upsell-config]');
  if (!configEl) return;

  var section = configEl.closest('[data-product-upsell]') || document.querySelector('[data-product-upsell]');
  var grid = section ? section.querySelector('[data-product-upsell-grid]') : null;
  var emptyMsg = section ? section.querySelector('[data-product-upsell-empty]') : null;
  var fallbackGrid = section ? section.querySelector('[data-product-upsell-fallback]') : null;
  if (!grid) return;

  var config = JSON.parse(configEl.textContent);

  function showFallbackOrEmpty() {
    grid.remove();
    if (fallbackGrid) {
      fallbackGrid.hidden = false;
      fallbackGrid.querySelectorAll('[data-product-upsell-static-add]').forEach(function (btn) {
        wireQuickAdd(btn, config.cartAddUrl);
      });
    } else if (emptyMsg) {
      emptyMsg.hidden = false;
    }
  }

  function renderProducts(products) {
    grid.innerHTML = '';
    if (!products.length) {
      showFallbackOrEmpty();
      return;
    }
    if (fallbackGrid) fallbackGrid.remove();

    products.forEach(function (product) {
      var variant = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0];
      var card = document.createElement('div');
      card.className = 'product-upsell__card';

      var link = document.createElement('a');
      link.href = product.url;
      link.className = 'product-upsell__card-link';

      var imageWrap = document.createElement('div');
      imageWrap.className = 'product-upsell__card-image';
      if (product.featured_image) {
        var img = document.createElement('img');
        img.src = product.featured_image;
        img.alt = product.title || '';
        img.loading = 'lazy';
        imageWrap.appendChild(img);
      }

      var title = document.createElement('p');
      title.className = 'product-upsell__card-title';
      title.textContent = product.title;

      var price = document.createElement('p');
      price.className = 'product-upsell__card-price';
      price.textContent = money(variant ? variant.price : product.price, config.currency);

      link.appendChild(imageWrap);
      link.appendChild(title);
      link.appendChild(price);
      card.appendChild(link);

      if (config.quickAdd && variant && variant.available) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-upsell__card-add';
        btn.dataset.variantId = variant.id;
        btn.textContent = 'Adicionar';
        wireQuickAdd(btn, config.cartAddUrl);
        card.appendChild(btn);
      }

      grid.appendChild(card);
    });
  }

  if (!config.productId) {
    showFallbackOrEmpty();
    return;
  }

  // Lisalva (n): primeiro complementares, depois relacionados; se ambos vierem vazios, mostra a mesma coleção (renderizada no servidor).
  function getRecs(intent) {
    return fetch(config.recommendationsUrl + '?product_id=' + config.productId + '&limit=' + config.limit + '&intent=' + intent)
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) {
        return (data.products || []).filter(function (p) { return String(p.id) !== String(config.productId) && p.available !== false; });
      })
      .catch(function () { return []; });
  }

  getRecs('complementary')
    .then(function (products) { return products.length ? products : getRecs('related'); })
    .then(function (products) { renderProducts(products); })
    .catch(function () { showFallbackOrEmpty(); });
})();